export default "__VITE_ASSET__1f5fa457__"